import React, { useEffect, useState } from 'react';
import { getDictionaryTrending } from '@/libs/api';
import TrendingList, { TrendingItem } from './TrendingList';

const DictHistory: React.FC = () => {
  const [data, setData] = useState<TrendingItem[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await getDictionaryTrending('trending', 20);
      if (result && result.result && Array.isArray(result.result.items)) {
        setData(result.result.items);
      }
    } catch (error) {
      console.error('获取词典热词失败:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <TrendingList
      title="词典热词"
      data={data}
      loading={loading}
      onRefresh={fetchData}
    />
  );
};

export default DictHistory;
